import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../../../assets/images/coyote-logo.jpg";
import mail from "../../../assets/images/auth/03.png";
import Card from "../../../components/Card";
import url from "../../../configs/config";

const ConfirmMail = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  let email = searchParams.get("email");

  if (email) {
    email = email.replace(/ /g, "+");
  }
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [showUrlError, setShowUrlError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isRequestSent = useRef(false);

  const navigate = useNavigate();

  useEffect(() => {
    const userToken = localStorage.getItem("coyote-token");
    if (userToken) {
      navigate("/dashboard");
      return;
    }

    if (!email || !token) {
      setShowAlertSuccess(false);
      setShowAlertError(false);
      setShowUrlError(true);
      setIsLoading(false);
    } else {
      if (!isRequestSent.current) {
        const handleSubmit = async () => {
          try {
            await axios.post(`${url.backendURL}user/verify-account`, {
              email,
              token,
            });
            setShowUrlError(false);
            setShowAlertSuccess(true);
            setShowAlertError(false);
          } catch (err) {
            setShowUrlError(false);
            setShowAlertSuccess(false);
            setShowAlertError(true);
          } finally {
            setIsLoading(false);
          }
          isRequestSent.current = true;
        };
        isRequestSent.current = true;
        handleSubmit();
      }
    }
  }, [email, token]);

  return (
    <>
      <section className="login-content">
        <Row className="m-0 align-items-center bg-white vh-100">
          <Col md="6" className="p-0">
            <Card className="card-transparent auth-card shadow-none d-flex justify-content-center mb-3">
              <Card.Body>
                <Link
                  to="/user/auth/sign-in"
                  className="navbar-brand d-flex align-items-center mb-3"
                >
                  <img
                    className="logo-title text-center mb-2 coyote-logo-image h-auto w-25"
                    src={logo}
                    alt="coyote-logo"
                  />
                </Link>
                {!isLoading && showUrlError === true ? (
                  <>
                    <h2 className="mt-3 mb-0">Error !</h2>
                    <p className="cnf-mail mb-1">Page Not Found.</p>
                    <div className="d-inline-block w-100">
                      <Link
                        to="/user/auth/sign-in"
                        className="btn btn-primary mt-3"
                      >
                        Go to Signin
                      </Link>
                    </div>
                  </>
                ) : !isLoading && showAlertSuccess === true ? (
                  <>
                    <h2 className="mt-3 mb-0">Success!</h2>
                    <p className="cnf-mail mb-1">
                      {" "}
                      Your email verification is successful. You can now proceed
                      to log in with your verified email address. <a href="/user/auth/sign-in"
                      style={{textDecoration :"none"}}
                      >Click here</a> to login to your account
                    </p>
                   
                  </>
                ) : !isLoading && (
                  <>
                    <h2 className="mt-3 mb-0">Error !</h2>
                    <p className="cnf-mail mb-1">
                      Verification token expired or invalid
                    </p>
                    <div className="d-inline-block w-100">
                      <Link
                        to="/user/auth/sign-in"
                        className="btn btn-primary mt-3"
                      >
                        Go to Signin
                      </Link>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col
            md="6"
            className="d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden"
          >
            <Image
              src={mail}
              className="img-fluid gradient-main animated-scaleX"
              alt="images"
            />
          </Col>
        </Row>
      </section>
    </>
  );
};

export default ConfirmMail;
